module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12748/images/airplane-globe-around-animated.gif"